import TrainingCompletionDetailsService from "../../apiServices/staff/trainingCompletionDetailsService";
import { setTrainingMatrics } from "../../store/slices/staff/trainingCompletionDetailsSlice";

export function getTrainingCompletionDetails(){
    return async function (dispatch: any, getState: any) {
        let response = await TrainingCompletionDetailsService.getTrainingCompletionDetails();
        if (response?.success === true) {
          dispatch(setTrainingMatrics(response.data));
        } else {
          console.log("error");
        }
      };
}